/** Errors for people: something they asked for that the league's rules don't allow */
export class LeagueError extends Error {
	constructor(message: string) {
		super(message);
		// Showdown shows errors whose name ends in "ErrorMessage" to the user, as a message rather than a crash
		this.name = 'LeagueErrorMessage';
	}
}
